import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { Button, Col, Modal, Radio, Row, Space } from 'antd';

import CustomRadioButton from '../CustomRadioButton/CustomRadioButton';
import './style.scss';
import { getGatherURL } from '../../data/store/portfolio/portfolioActions';

const ModalNewSelectPortfolio = ({ open, closeModal, userId, setOpenModalNew }) => {
  const { t } = useTranslation('');
  const dispatch = useDispatch();

  const [portfolioType, setPortfolioType] = useState(null);

  const handleManually = () => {
    setOpenModalNew(true);
    closeModal();
  };

  const handleChangeType = ({target: {value}}) => {
  setPortfolioType(value);
  };

  const onSubmit = () => {
    if(portfolioType === 'manually') {
      handleManually();
    } else {
      dispatch(getGatherURL({accountId: userId, closeModal}));
    }
  };

  return (
    <Modal
      width={700}
      className="modal-portfolio portfoliotype" 
      open={open}
      onCancel={closeModal}
      footer={null}
      closable={false}
      zIndex={1620}
      destroyOnClose
      classNames={{
        content: 'portfoliotype-modal',
      }}
    >
      <Row justify="start" align={'middle'}>
        <Col className="modal-newportfolio-title">{t('CREATE_PORTFOLIO')}</Col>
      </Row>
      <div className="color-box-header">
      </div>
      <h2 className='select-portfoliotype-title'>{t('WANT_TO_CREATE_IT')}</h2>
      <div className='portfoliotype-content-wrapper'>
        <div className='portfoliotype-btn-wrap'>
          <Radio.Group
            value={portfolioType}
            onChange={handleChangeType}
            className="checkbox-block">
            <Space direction="horizontal" align="center">
              <CustomRadioButton value="manually">
                {t('MANUALLY')}
              </CustomRadioButton>
              <CustomRadioButton value="njorda">
                {t('FROM_NJORDA')}
              </CustomRadioButton>
            </Space>
          </Radio.Group>
        </div>
        <Row className="modal-newportfolio-button-wrapper">
          <Button
            type='text' 
            className='modal-action-btn cancel-btn' 
            onClick={closeModal }>
            {t('CANCEL')}
          </Button>
          <Button
            type='default'
            className='modal-action-btn save-btn continue-btn' 
            onClick={onSubmit}>
            {t('CONTINUE')}
          </Button>
        </Row>
      </div>

    </Modal>
  );
};

export default ModalNewSelectPortfolio;

ModalNewSelectPortfolio.propTypes = {
  open: PropTypes.bool,
  closeModal: PropTypes.func,
  setOpenModalNew: PropTypes.func,
  userId: PropTypes.string,
};
